import {
  Activity,
  Briefcase,
  Building2,
  Calendar,
  Clock,
  Folder,
  LogIn,
  LogOut,
  Phone,
  Scale,
  Settings,
  Shield,
  Upload,
  User,
  UserMinus,
  UserPlus,
  Users,
  Wallet,
} from "lucide-react";

const ICON_MAP = {
  upload: Upload,
  "user-plus": UserPlus,
  "user-minus": UserMinus,
  users: Users,
  user: User,
  phone: Phone,
  wallet: Wallet,
  scale: Scale,
  building: Building2,
  folder: Folder,
  shield: Shield,
  "log-in": LogIn,
  "log-out": LogOut,
  activity: Activity,
  bell: Activity,
  briefcase: Briefcase,
  settings: Settings,
  clock: Clock,
  calendar: Calendar,
};

const COLOR_MAP = {
  collect: "bg-collect/10 text-collect ring-collect/15",
  sky: "bg-sky-50 text-sky-600 ring-sky-600/10",
  emerald: "bg-emerald-50 text-emerald-600 ring-emerald-600/10",
  amber: "bg-amber-50 text-amber-700 ring-amber-600/10",
  rose: "bg-rose-50 text-rose-600 ring-rose-600/10",
  primary: "bg-primary/[0.06] text-primary ring-primary/10",
};

export function formatActivityRelative(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const diffMs = Date.now() - date.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function ActivityIcon({ icon, color, className = "h-9 w-9" }) {
  const Icon = ICON_MAP[icon] || Activity;
  const tone = COLOR_MAP[color] || COLOR_MAP.primary;
  return (
    <span className={`flex shrink-0 items-center justify-center rounded-xl ring-1 ${tone} ${className}`}>
      <Icon className="h-4 w-4" strokeWidth={2.25} />
    </span>
  );
}
